<template>
  <div>
    <div class="row">
      <div class="col-md-12">
          <div class="form-access">
          <a href="#" class="form-back" @click="backParent">
              <i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back
          </a>
          </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
            <h4 class="mt-0 header-title">User's Role</h4>
            <p class="text-muted mb-3">Prevent Menu Users</p>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group row">
                        <label for="name" class="col-sm-3 col-form-label text-right">Name</label>
                        <div class="col-sm-9">
                            <input class="form-control" type="text" id="name" v-model="role.name">
                            <div class="invalid-feedback">
                              {{ name_message }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-4">
                  <h4 class="mt-0 header-title">Main Menu:</h4>
                  <div class="form-group row">
                      <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                      <div class="col-sm-9">
                          <!-- purchasing manufacture sales finance master user -->
                          <div class="custom-control custom-checkbox">
                            <input v-model="role.permissions.purchasing" type="checkbox" class="custom-control-input" id="purchasing" data-parsley-multiple="groups" data-parsley-mincheck="2">
                            <label class="custom-control-label" for="purchasing">Purchasing</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input v-model="role.permissions.manufacture" type="checkbox" class="custom-control-input" id="manufacture" data-parsley-multiple="groups" data-parsley-mincheck="2">
                            <label class="custom-control-label" for="manufacture">Manufacture</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input v-model="role.permissions.sales" type="checkbox" class="custom-control-input" id="sales" data-parsley-multiple="groups" data-parsley-mincheck="2">
                            <label class="custom-control-label" for="sales">Sales</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input v-model="role.permissions.salesman" type="checkbox" class="custom-control-input" id="salesman" data-parsley-multiple="groups" data-parsley-mincheck="2">
                            <label class="custom-control-label" for="salesman">Salesman</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input v-model="role.permissions.finance" type="checkbox" class="custom-control-input" id="finance" data-parsley-multiple="groups" data-parsley-mincheck="2">
                            <label class="custom-control-label" for="finance">Finance</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input v-model="role.permissions.master" type="checkbox" class="custom-control-input" id="master" data-parsley-multiple="groups" data-parsley-mincheck="2">
                            <label class="custom-control-label" for="master">Master</label>
                          </div>
                          <div class="custom-control custom-checkbox">
                            <input v-model="role.permissions.user" type="checkbox" class="custom-control-input" id="user" data-parsley-multiple="groups" data-parsley-mincheck="2">
                            <label class="custom-control-label" for="user">Human Resources</label>
                          </div>
                      </div>
                  </div>
                  <h4 class="mt-0 header-title">Permission All:</h4>
                  <div class="form-group row">
                    <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                    <div class="col-sm-9">
                        <!-- purchasing manufacture sales finance master user -->
                        <div class="custom-control custom-checkbox">
                          <input v-model="role.permissions.company_select_all" type="checkbox" class="custom-control-input" id="company_select_all" data-parsley-multiple="groups" data-parsley-mincheck="2">
                          <label class="custom-control-label" for="company_select_all">Select All Company</label>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <h4 class="mt-0 header-title">Sub Menu:</h4>
                  <div class="form-group row">
                    <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                    <div class="col-sm-9">
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.customer" type="checkbox" class="custom-control-input" id="customer" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="customer">Customer</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.product" type="checkbox" class="custom-control-input" id="product" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="product">Product</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.purchase_report" type="checkbox" class="custom-control-input" id="purchase_report" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="purchase_report">Purchase Report</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.price" type="checkbox" class="custom-control-input" id="price" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="price">Price</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.promo" type="checkbox" class="custom-control-input" id="promo" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="promo">Promo</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.finance_report" type="checkbox" class="custom-control-input" id="finance_report" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="finance_report">Finance Report</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.message" type="checkbox" class="custom-control-input" id="message" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="message">Message</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.payment" type="checkbox" class="custom-control-input" id="payment" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="payment">Payment</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.margin_on_sales" type="checkbox" class="custom-control-input" id="margin_on_sales" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="margin_on_sales">View Margin on Sales</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sale_report" type="checkbox" class="custom-control-input" id="sale_report" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sale_report">Sale Report</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.project" type="checkbox" class="custom-control-input" id="project" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="project">Project</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.workshop" type="checkbox" class="custom-control-input" id="workshop" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="workshop">Workshop</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.report_manufacture_summary_product" type="checkbox" class="custom-control-input" id="report_manufacture_summary_product" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="report_manufacture_summary_product">Manufacture Summary Product</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.report_manufacture_summary" type="checkbox" class="custom-control-input" id="report_manufacture_summary" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="report_manufacture_summary">Manufacture Summary</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.report_sales_laba_kotor" type="checkbox" class="custom-control-input" id="report_sales_laba_kotor" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="report_sales_laba_kotor">Laporan Laba Kotor</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.convert_submenu_view" type="checkbox" class="custom-control-input" id="convert_submenu_view" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="convert_submenu_view">Convert Submenu View</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.adjust_submenu_view" type="checkbox" class="custom-control-input" id="adjust_submenu_view" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="adjust_submenu_view">Adjust Submenu View</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <h4 class="mt-0 header-title">Manufacture:</h4>
                  <div class="form-group row">
                    <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                    <div class="col-sm-9">
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.manufacture_cogs" type="checkbox" class="custom-control-input" id="manufacture_cogs" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="manufacture_cogs">Manufacture COGS (view)</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.manufacture_journal" type="checkbox" class="custom-control-input" id="manufacture_journal" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="manufacture_journal">Manufacture Journal</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.manufacture_unlock" type="checkbox" class="custom-control-input" id="manufacture_journal" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="manufacture_journal">Manufacture Unlock</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.inventory_on_hand_delete" type="checkbox" class="custom-control-input" id="inventory_on_hand_delete" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="inventory_on_hand_delete">Film Delete</label>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-4">
                <h4 class="mt-0 header-title">Product:</h4>
                <div class="form-group row">
                  <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                  <div class="col-sm-9">
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.product_summary_cost_view_cost" type="checkbox" class="custom-control-input" id="product_summary_cost_view_cost" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="product_summary_cost_view_cost">Summary Cost view Cost (hpp)</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.product_stock_card_cogs" type="checkbox" class="custom-control-input" id="product_summary_cost_view_cost" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="product_stock_card_cogs">Kartu Stock (HPP)</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-4">
                <h4 class="mt-0 header-title">Purchasing:</h4>
                <div class="form-group row">
                  <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                  <div class="col-sm-9">
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.purchasing_add_product_line" type="checkbox" class="custom-control-input" id="purchasing_add_product_line" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="purchasing_add_product_line">Add Product Line</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.purchasing_backdate" type="checkbox" class="custom-control-input" id="purchasing_backdate" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="purchasing_backdate">Purchasing Backdate</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.purchasing_unlock" type="checkbox" class="custom-control-input" id="purchasing_unlock" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="purchasing_unlock">Purchasing Unlock</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.purchasing_delete" type="checkbox" class="custom-control-input" id="purchasing_delete" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="purchasing_delete">Purchasing Delete</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.purchasing_order_delete" type="checkbox" class="custom-control-input" id="purchasing_order_delete" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="purchasing_order_delete">Order Delete</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.purchasing_order_unlock" type="checkbox" class="custom-control-input" id="purchasing_order_unlock" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="purchasing_order_unlock">Order Unlock</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <h4 class="mt-0 header-title">Purchasing Payment:</h4>
                <div class="form-group row">
                  <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                  <div class="col-sm-9">
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.purchasing_payment_view" type="checkbox" class="custom-control-input" id="purchasing_payment_view" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="purchasing_payment_view">View Payment</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.purchasing_payment_create_admin" type="checkbox" class="custom-control-input" id="purchasing_payment_create_admin" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="purchasing_payment_create_admin">Purchasing Create Payment by admin</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.purchasing_payment_super_admin" type="checkbox" class="custom-control-input" id="purchasing_payment_super_admin" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="purchasing_payment_super_admin">All Permission</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-4">
                  <h4 class="mt-0 header-title">Sale:</h4>
                  <div class="form-group row">
                    <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                    <div class="col-sm-9">
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sale_add_product_line" type="checkbox" class="custom-control-input" id="sale_add_product_line" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sale_add_product_line">Add Product Line</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.purchasing_price_input" type="checkbox" class="custom-control-input" id="purchasing_price_input" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="purchasing_price_input">Input Price</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sale_backdate" type="checkbox" class="custom-control-input" id="sale_backdate" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sale_backdate">Sale BackDate</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sale_delete" type="checkbox" class="custom-control-input" id="sale_delete" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sale_delete">Sales Delete</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sale_unlock" type="checkbox" class="custom-control-input" id="sale_unlock" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sale_unlock">Sale unlock</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sale_order_delete" type="checkbox" class="custom-control-input" id="sale_order_delete" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sale_order_delete">Order Delete</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sale_order_unlock" type="checkbox" class="custom-control-input" id="sale_order_unlock" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sale_order_unlock">Order unlock</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <h4 class="mt-0 header-title">Sale Payment:</h4>
                  <div class="form-group row">
                    <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                    <div class="col-sm-9">
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sale_payment_view" type="checkbox" class="custom-control-input" id="sale_payment_view" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sale_payment_view">View Payment</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sale_payment_approve" type="checkbox" class="custom-control-input" id="sale_payment_approve" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sale_payment_approve">Approve Payment</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sale_payment_void" type="checkbox" class="custom-control-input" id="sale_payment_void" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sale_payment_void">Void Payment</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sale_payment_backdate" type="checkbox" class="custom-control-input" id="sale_payment_backdate" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sale_payment_backdate">Payment Backdate</label>
                      </div>
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sales_payment_create_admin" type="checkbox" class="custom-control-input" id="sales_payment_create_admin" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sales_payment_create_admin">Sales Create Payment by admin</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <h4 class="mt-0 header-title">Sale Submenu:</h4>
                  <div class="form-group row">
                    <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                    <div class="col-sm-9">
                      <div class="custom-control custom-checkbox">
                        <input v-model="role.permissions.sale_laba_kotor_view" type="checkbox" class="custom-control-input" id="sale_laba_kotor_view" data-parsley-multiple="groups" data-parsley-mincheck="2">
                        <label class="custom-control-label" for="sale_laba_kotor_view">Laba Kotor</label>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <h4 class="mt-0 header-title">Convert:</h4>
                <div class="form-group row">
                  <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                  <div class="col-sm-9">
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.convert_cost_view" type="checkbox" class="custom-control-input" id="convert_cost_view" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="convert_cost_view">COST view</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.convert_view" type="checkbox" class="custom-control-input" id="convert_view" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="convert_view">View</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.convert_delete" type="checkbox" class="custom-control-input" id="convert_delete" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="convert_delete">Delete</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <h4 class="mt-0 header-title">Dashboard:</h4>
                <div class="form-group row">
                  <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                  <div class="col-sm-9">
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.dashboard_view" type="checkbox" class="custom-control-input" id="dashboard_view" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="dashboard_view">View</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.dashboard_manufacture_view" type="checkbox" class="custom-control-input" id="dashboard_manufacture_view" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="dashboard_manufacture_view">Manufacture Table View</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.login_unlimited" type="checkbox" class="custom-control-input" id="login_unlimited" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="login_unlimited">Login Unlimited time</label>
                    </div>
                  </div>
                </div>
                <h4 class="mt-0 header-title">Dashboard Sub Menu</h4>
                <div class="form-group row">
                  <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                  <div class="col-sm-9">
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.sub_dashboard_report" type="checkbox" class="custom-control-input" id="sub_dashboard_report" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="sub_dashboard_report">Report</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.sub_dashboard_report_stock" type="checkbox" class="custom-control-input" id="sub_dashboard_report_stock" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="sub_dashboard_report_stock">Report Stock</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-md-4">
                <h4 class="mt-0 header-title">Finance:</h4>
                <div class="form-group row">
                  <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                  <div class="col-sm-9">
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.finance_laba_rugi" type="checkbox" class="custom-control-input" id="finance_laba_rugi" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="finance_laba_rugi">Laba Rugi view</label>
                    </div>
                  </div>
                  <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                  <div class="col-sm-9">
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.finance_kas_besar_piutang_menu_view" type="checkbox" class="custom-control-input" id="finance_kas_besar_piutang_menu_view" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="finance_kas_besar_piutang_menu_view">Kas Besar Piutang Menu view</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.finance_buku_besar_persediaan" type="checkbox" class="custom-control-input" id="finance_buku_besar_persediaan" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="finance_buku_besar_persediaan">Buku Besar Persediaan</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.finance_neraca" type="checkbox" class="custom-control-input" id="finance_neraca" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="finance_neraca">Neraca</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.finance_delete_journal" type="checkbox" class="custom-control-input" id="finance_delete_journal" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="finance_delete_journal">Delete Journal</label>
                    </div>
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.finance_cash_unlock" type="checkbox" class="custom-control-input" id="finance_cash_unlock" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="finance_cash_unlock">Unlock Cash</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-md-4">
                <h4 class="mt-0 header-title">Report</h4>
                <div class="form-group row">
                  <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                  <div class="col-sm-9">
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.laporan_penerimaan_tagihan_process" type="checkbox" class="custom-control-input" id="laporan_penerimaan_tagihan_process" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="laporan_penerimaan_tagihan_process">Process Laporan Penerimaan Tagihan</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-4">
                <h4 class="mt-0 header-title">Customer</h4>
                <div class="form-group row">
                  <label for="variants" class="col-sm-3 col-form-label text-right"></label>
                  <div class="col-sm-9">
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.customer_active" type="checkbox" class="custom-control-input" id="customer_active" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="customer_active">Can Active</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="customer_sales_plafond_enable" class="col-sm-3 col-form-label text-right"></label>
                  <div class="col-sm-9">
                    <div class="custom-control custom-checkbox">
                      <input v-model="role.permissions.customer_sales_plafond_enable" type="checkbox" class="custom-control-input" id="customer_sales_plafond_enable" data-parsley-multiple="groups" data-parsley-mincheck="2">
                      <label class="custom-control-label" for="customer_sales_plafond_enable">Enable Plafond in sales</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      </div>
      <div class="card-footer">
        <button class="btn btn-primary pull-right" @click="updateAll" v-if="role.id">Update</button>
        <button class="btn btn-primary pull-right" @click="saveAll" v-else>Save</button>
      </div>
    </div>
    <!-- <pre>{{ role }}</pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { roleUrl, getHeader } from '@/config'

export default {
  name: 'RoleForm',
  props: ['role'],
  data () {
    return {
      name_message: null
    }
  },
  methods: {
    validation: function () {
      document.getElementById('name').classList.remove('is-invalid')
    },
    updateAll: function () {
      axios.put(roleUrl + '/' + this.role.id, this.role, { headers: getHeader() })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    saveAll: function () {
      this.validation()
      axios.post(roleUrl, this.role, { headers: getHeader() })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response.data)
          for (var property in error.response.data) {
            var element = document.getElementById(property)
            if (element) {
              element.classList.add('is-invalid')
              if (property === 'name') {
                this.name_message = error.response.data[property][0]
              }
            }
          }
        })
    },
    backParent: function () {
      this.validation()
      this.$emit('backClicked')
    }
  }
}
</script>
